import { Paragraph } from '@welbe/web-design-system';
import { ReactComponent as SadFace } from 'App/assets/img/sad-face.svg';
import { Button } from '@welbe/design-system';
import React from 'react';
import { Container } from './ErrorScreen.styles';

export const ErrorScreen = ({ onRefresh }: { onRefresh: () => void }) => {
	return (
		<Container>
			<SadFace width="72px" height="72px" />
			<Paragraph margin="20px 0" fontSize="16px" fontWeight="500">
				Hubo un error al cargar los riesgos, por favor intenta de nuevo
			</Paragraph>
			<Button width="150px" onClick={onRefresh}>
				Recargar
			</Button>
		</Container>
	);
};
